import { StyleFunctionProps } from "@chakra-ui/theme-tools/dist/declarations/src/component";
import { tinycolor } from "@ctrl/tinycolor";
import { getColor } from "@chakra-ui/theme-tools";
import apColorConfig from "./APColorConfig";
import { SystemStyleObject, theme } from "@chakra-ui/react";
import { mergeDeep } from "../utils";
import { ColorInput } from "@ctrl/tinycolor/dist";

const solid = (props: StyleFunctionProps): SystemStyleObject => {
  if (!getColor(props.theme, `${props.colorScheme}.fg`)) {
    props.colorScheme = "secondary";
  }
  const baseColor = tinycolor(getColor(props.theme, `${props.colorScheme}.fg`, `${props.colorScheme}.500`))

  const isDark = baseColor.getLuminance() < 0.4;
  const color = isDark ? apColorConfig.white : apColorConfig.black;

  const highlight = isDark ? baseColor.lighten(10) : baseColor.darken(7);
  const active = highlight.darken(15);
  const disabled = baseColor.lighten(23);

  const solidStyle = {
    color: getColor(props.theme, `${props.colorScheme}.contrast`, color),
    boxSizing: "border-box",
    bg: `${baseColor}`,
    _hover: {
      bg: `${highlight}`,
    },
    _active: {
      bg: `${active}`,
    },
    _focus: {
      bg: `${baseColor}`,
    },
    _disabled: {
      opacity: 1,
      bg: `${disabled}`,
      pointerEvents: "none",
    }
  };

  return mergeDeep(theme.components.Button.variants.solid(props), solidStyle);
};

const raised = (props: StyleFunctionProps): SystemStyleObject => {
  const baseStyle = solid(props);
  const baseColor = tinycolor(baseStyle.bg as ColorInput)

  const isDark = baseColor.getLuminance() < 0.4;

  const shadowColor = tinycolor(baseColor).darken(15);
  const shadowHighlight = isDark ? shadowColor.lighten(10) : shadowColor.darken(7);
  const shadowDisabled = shadowColor.lighten(35);

  const raisedStyle = {
    boxShadow: `0 0.25rem 0 ${shadowColor}`,
    _disabled: {
      boxShadow: `0 0.25rem 0 ${shadowDisabled}`,
    },
    _hover: {
      boxShadow: `0 0.25rem 0 ${shadowHighlight}`,
    },
    _focus: {
      _before: {
        bottom: "-0.5rem",
      }
    },
    border: "unset"
  }

  return mergeDeep(baseStyle, raisedStyle);
};

const icon = (props: StyleFunctionProps): SystemStyleObject => {
  const iconStyle = {
    width: "2em",
    height: "2em",
    minWidth: "2em",
    minHeight: "2em",
    padding: "0.5em 0.5em !important",
    margin: "0 !important",
    rounded: "xl",
    display: "flex",
    alignItems: "center",
    fontSize: "inherit",
  }
  return mergeDeep(solid(props), iconStyle);
};

const raisedIcon = (props: StyleFunctionProps): SystemStyleObject => {
  const iconStyle = {
    width: "2em",
    height: "2em",
    minWidth: "2em !important",
    minHeight: "2em !important",
    padding: "0.5em 0.5em !important",
    margin: "0 !important",
    rounded: "xl",
    display: "flex",
    alignItems: "center",
    fontSize: "inherit",
  }
  return mergeDeep(raised(props), iconStyle);
};

const outline = (props: StyleFunctionProps): SystemStyleObject => {
  if (!getColor(props.theme, `${props.colorScheme}.fg`)) {
    props.colorScheme = "secondary";
  }

  const baseColor = tinycolor(getColor(props.theme, `${props.colorScheme}.fg`, `${props.colorScheme}.500`))

  const shadowHighlight = baseColor.getLuminance() < 0.4 ? baseColor.lighten(10) : baseColor.darken(7);

  const bgColor = tinycolor(apColorConfig.white);
  const highlight = bgColor.darken(5);
  const active = bgColor.darken(15);

  const outlineStyle = {
    color: `${getColor(props.theme, `${props.colorScheme}.contrast`, apColorConfig.black)}`,
    bg: `${bgColor}`,
    border: `2px solid`,
    borderColor: `${baseColor}`,
    boxShadow: "unset",
    _active: {
      bg: `${active}`,
    },
    _hover: {
      bg: `${highlight}`,
      borderColor: `${shadowHighlight}`,
    },
    _focus: {
      bg: `${baseColor}`,
    }
  }
  return mergeDeep(theme.components.Button.variants.outline(props), outlineStyle);
};

const raisedOutline = (props: StyleFunctionProps): SystemStyleObject => {
  const baseStyle = outline(props);
  if (!getColor(props.theme, `${props.colorScheme}.fg`)) {
    props.colorScheme = "secondary";
  }

  const baseColor = tinycolor(getColor(props.theme, `${props.colorScheme}.fg`, `${props.colorScheme}.500`))
  const shadowHighlight = baseColor.getLuminance() < 0.4 ? baseColor.lighten(10) : baseColor.darken(5);

  const raisedOutlineStyle = {
    boxShadow: `0 0.25rem 0 ${baseColor}`,
    _hover: {
      boxShadow: `0 0.25rem 0 ${shadowHighlight}`,
    }
  }
  return mergeDeep(baseStyle, raisedOutlineStyle);
};

const tag = (props: StyleFunctionProps) => {
  const tagStyle = {
    borderRadius: `1rem 1rem 0 0`,
    // _focus: {
    //   _after: {
    //     borderBottomWidth: 0
    //   }
    // },
  }

  return mergeDeep(solid(props), tagStyle);
};

export const apButtonConfig = {
  defaultProps: {
    variant: 'solid',
    colorScheme: 'primary',
  },
  baseStyle: {
    fontWeight: 400,
    fontSize: ["md", "lg"],
    rounded: "full",
    padding: ["0.5rem 1.25rem !important", "0.75rem 1.5rem !important"],
    webkitTapHighlightColor: "rgba(0,0,0,0)",
    // _focus: {
    //   boxShadow: "",
    //   _before: {
    //     content: '""',
    //     display: "block",
    //     position: "absolute",
    //     borderRadius: "inherit",
    //     top: "-0.25rem", right: "-0.25rem", bottom: "-0.25rem", left: "-0.25rem",
    //     border: `0.2rem solid`,
    //     borderColor: "violet",
    //   }
    // }
  },
  variants: {
    solid: solid,
    raised: raised,
    icon: icon,
    raisedIcon: raisedIcon,
    outline: outline,
    raisedOutline: raisedOutline,
    tag: tag,
  }
}